import { UserRoleDTO } from 'models'
import { PeriodValue } from '@touche-lts/panel-ui/dist/components/shared/date-range-picker'

export enum UsersInStoreTableSortProps {
  NAME = 'name',
  ROLE = 'role',
  DATE = 'createdDate'
}

export interface UsersInStoreTableSearchProps {
  name: string
  role: UserRoleDTO
  addedOnPeriod: PeriodValue // TODO: replace with the new date period picker value type
}
